import Vue from 'vue'

Vue.mixin({
  methods: {
    getInicisMethod() {
      let obj
      if (this.order) {
        obj = this.order
      } else if (this.offer) {
        obj = this.offer
      }
      if (obj.setleMthCode === 'settlement_method.creditcard') {
        return 'CARD'
      } else if (obj.setleMthCode === 'settlement_method.account_transfer') {
        return 'BANK'
      } else if (
        obj.setleMthCode === 'settlement_method.virtual_account_transfer'
      ) {
        return 'VBANK'
      } else if (obj.setleMthCode === 'settlement_method.mobile') {
        return 'MOBILE'
      }
      return ''
    }
  }
})
